var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "internal-page-main-section faq-section-main forum-main col-12"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "MainForum" }, [
            _c("div", { staticClass: "ForumTop" }, [
              _c("div", { staticClass: "ForumSearch" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchManagerToolBox,
                        expression: "searchManagerToolBox"
                      }
                    ],
                    staticClass: "form-control bg-none border-0 forum-input",
                    attrs: {
                      type: "text",
                      "aria-describedby": "button-addon4",
                      id: "searchManagerToolBox",
                      placeholder: "Search",
                      name: "searchManagerToolBox"
                    },
                    domProps: { value: _vm.searchManagerToolBox },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchCall()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchManagerToolBox = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-prepend border-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link text-info",
                        attrs: { id: "button-addon4", type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.searchCall()
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-search" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link text-info clear-search",
                        attrs: { id: "button-clear", type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.clearSearch()
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("v-select", {
                        staticClass: "input-field-si",
                        attrs: {
                          name: "sortManagerToolBox",
                          placeholder: "Select field for sorting",
                          label: "text",
                          options: _vm.sortManagerToolBoxArr,
                          clearable: false
                        },
                        model: {
                          value: _vm.sortManagerToolBox,
                          callback: function($$v) {
                            _vm.sortManagerToolBox = $$v
                          },
                          expression: "sortManagerToolBox"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ForumPage" }, [
              _c("div", { staticClass: "ForumListing" }, [
                _vm.managerToolBoxArr &&
                _vm.managerToolBoxArr.folderData &&
                  _vm.managerToolBoxArr.folderData.length > 0
                  ? _c(
                      "div",
                      { staticClass: "internal-listing-container" },
                      [
                        _vm._l(_vm.managerToolBoxArr.folderData, function(
                          managerToolBox,
                          index
                        ) {
                          return [
                            _c(
                              "div",
                              { key: index, staticClass: "single-listing" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "upload-doc-img" },
                                  [
                                    managerToolBox.doc_extension.toLowerCase() ==
                                    "gif"
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                "/static/images/link-icon.png"
                                            }
                                          })
                                        ]
                                      : managerToolBox.doc_extension.toLowerCase() ==
                                          "doc" ||
                                        managerToolBox.doc_extension.toLowerCase() ==
                                          "docx"
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src: "/static/images/doc-icon.png"
                                            }
                                          })
                                        ]
                                      : managerToolBox.doc_extension.toLowerCase() ==
                                          "xls" ||
                                        managerToolBox.doc_extension.toLowerCase() ==
                                          "xlsx"
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src: "/static/images/xl-icon.png"
                                            }
                                          })
                                        ]
                                      : managerToolBox.doc_extension.toLowerCase() ==
                                          "ppt" ||
                                        managerToolBox.doc_extension.toLowerCase() ==
                                          "pptx"
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src: "/static/images/ppt-icon.png"
                                            }
                                          })
                                        ]
                                      : managerToolBox.doc_extension.toLowerCase() ==
                                        "pdf"
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src: "/static/images/pdf-icon.png"
                                            }
                                          })
                                        ]
                                      : [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                "/static/images/link-icon.png"
                                            }
                                          })
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "single-listing-text" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        attrs: { title: managerToolBox.title }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.stringTrim(
                                              managerToolBox.title,
                                              60
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "download" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "downloadnow",
                                      attrs: { href: "#", id: "id" + index },
                                      on: {
                                        click: function($event) {
                                          return _vm.getSignedUrlPath(
                                            managerToolBox.document
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Download Now!")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "listing-user-info1" },
                                  [
                                    _c("div", { staticClass: "user-details" }, [
                                      _c(
                                        "div",
                                        { staticClass: "listing-user" },
                                        [
                                          _vm._v(
                                            _vm._s(managerToolBox.updated_name)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "listing-block-info" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "listing-date" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  managerToolBox.updated_date
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "listing-time" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  managerToolBox.updated_time
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "internal-listing-container",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _vm._v(
                          "\n                            Data Not Available\n                        "
                        )
                      ]
                    ),
                _vm._v(" "),
                _vm.managerToolBoxArr.total_rows >=
                _vm.managerToolBoxArr.per_page
                  ? _c(
                      "div",
                      [
                        _c("b-pagination", {
                          attrs: {
                            align: "center",
                            "prev-text": "‹ Previous",
                            "next-text": "Next ›",
                            "total-rows": _vm.managerToolBoxArr.total_rows,
                            "per-page": _vm.managerToolBoxArr.per_page
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Manager Tool Box ")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47f2807e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f2807e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentsManagerToolBox.vue
// module id = null
// module chunks = 